export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getPaginatedFiles(_, page) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/file/index?page=" + page)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        deleteFile(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/file/delete/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        }
    },
}

